import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    async postFichaDeDados(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada. Entre novamente.');
        ApiService.setHeader();
        const { data } = await ApiService.post('fichasDeDados/access/salvar', dados);
        return data;
    },
    getFichasDeDados(context, dados) {
        if ((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados = {
                pagina: 1,
                quantidadePorPagina: 25
            };
        }

        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fichasDeDados/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getFichaDeDados(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fichasDeDados/access/obter", { ID_ATENDIMENTO_TIPO: dados.id, componente: dados.componente }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    deleteFichaDeDados(context, idFichaDeDados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fichasDeDados/access/excluir", { ID_ATENDIMENTO_TIPO: idFichaDeDados }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};